import { LucideX } from 'lucide-react'
import type { PopupProps } from 'react-map-gl'
import { Popup } from 'react-map-gl'
import { Button } from '~/components/ui'
import { cn } from '~/utils'

type MobilePopupProps = PopupProps &
  React.RefAttributes<mapboxgl.Popup> & {
    children: React.ReactNode
    mdDown: boolean // Moved to prop. useBreakpoint was not working here
    className?: string
    onClose?: () => void
  }

export default function MobilePopup({
  children,
  mdDown,
  className,
  onClose,
  ...props
}: MobilePopupProps) {
  if (mdDown) {
    return (
      <div
        className="fixed bottom-0 left-0 right-0 top-0 z-50"
        onClick={onClose}>
        <div
          className={cn(
            'fixed left-1/2 top-1/2 z-50 flex w-[95dvw] max-w-[95dvw] -translate-x-1/2 -translate-y-1/2 flex-col rounded-md bg-background',
            className
          )}>
          <Button
            variant="ghost"
            size="default"
            className="absolute right-0 top-0 h-10 bg-background px-3"
            onClick={onClose}>
            <LucideX className="h-4 w-4" />
            <span className="sr-only">Close</span>
          </Button>
          <div className="-mt-1.5 p-4">{children}</div>
        </div>
      </div>
    )
  }

  return (
    <Popup className={className} {...props} onClose={onClose}>
      {children}
    </Popup>
  )
}
